import core = egr.wcf.core;
import utils = egr.wcf.utils;
import { GlobalHelper } from './GlobalHelper';
import { ArticleActions } from '../actions/ArticleActions';

export abstract class SceneHelper {
    /*
    private static insertElementFromMesh(pMesh: BABYLON.AbstractMesh): void {
        if (pMesh == null) {
            return;
        }
        SceneHelper.insertElement(new core.mdl.SceneElement(pMesh));
    }
    */

    public static insertElements(pElements: Array<core.mdl.SceneElement>): Promise<void> {
        if (pElements == null || pElements.length === 0) {
            return (Promise.resolve());
        }

        utils.planning.placeElementsInViewCenter(
            pElements,
            GlobalHelper.activeView, GlobalHelper.coreApp.model
        );

        GlobalHelper.activeView.cameraControl.zoomToFitElements(pElements);

        const tInsertCommand: core.cmd.InsertElements = new core.cmd.InsertElements(GlobalHelper.coreApp, pElements);
        return GlobalHelper.coreApp.commands.executeCommand(tInsertCommand).then(
            (pExecuted) => {
                GlobalHelper.coreApp.model.setSelection(pElements);
            }
        ).then((): void => {
            ArticleActions.invalidateArticleList();
        });
    }

    public static insertElement(pElement: core.mdl.SceneElement): Promise<void> {
        if (pElement == null) {
            return (Promise.resolve());
        }
        return (SceneHelper.insertElements([pElement]));
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/SceneHelper.ts